import { curryN } from "ramda";
export default curryN(2, (ks, x) => ks.map((k) => x[k]));
//# sourceMappingURL=pickVals.mjs.map